import { render, staticRenderFns } from "./SquaredIndex.vue?vue&type=template&id=ca60c022&"
import script from "./SquaredIndex.vue?vue&type=script&lang=js&"
export * from "./SquaredIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports